import { Action, action } from 'easy-peasy';
export interface AttachStoreModel {
  isOpen: boolean;
  close: Action<AttachStoreModel>;
  open: Action<AttachStoreModel, string>;
  id: string;
}

const attachStoreModel: AttachStoreModel = {
  isOpen: false,
  id: '',
  close: action((s) => {
    s.isOpen = false;
  }),
  open: action((s, payload) => {
    s.isOpen = true;
    s.id = payload;
  }),
};

export default attachStoreModel;
